import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useDispatch } from 'react-redux';
import { Layout } from 'antd';
const { Content } = Layout;
import Toast from 'widgets/Toast';
const toast = Toast();
import PrimaryHeader from './PrimaryHeader';
import SecondaryHeader from './SecondaryHeader';
import SiteFooter from './SiteFooter';
import styles from './NavigationLayout.scss';
import { authenticateUser } from 'actions/user';
import PageLoader from '../shared/PageLoader';
import { redirect } from 'actions/navigation';
import routePaths from '../Router/routePaths';
import useTenantHook from '../../hooks/useTenantHook';

const NavigationLayout = ({
  children,
  location,
  isMobile,
  isContentFullWidth,
}) => {
  const dispatch = useDispatch();
  const { currentTenant, instantiateTenant } = useTenantHook();

  const [auhtenticated, setAuhtenticated] = useState('loading'); // loading | success | error

  const authenticate = async () => {
    await dispatch(authenticateUser())
      .then(() => setAuhtenticated('success'))
      .catch(() => setAuhtenticated('error'));
  };

  useEffect(() => {
    authenticate();
  }, []);

  useEffect(() => {
    if (!currentTenant?.id) {
      instantiateTenant().catch((errorReason) => {
        // Tenant not found. Must select a tenant first.
        toast.info(errorReason);
        dispatch(redirect(routePaths.dashboard));
      });
    }
  }, [currentTenant]);

  return auhtenticated === 'loading' ? (
    <PageLoader />
  ) : (
    <Layout className={cx(styles.root, { [styles.isMobile]: isMobile })}>
      <PrimaryHeader location={location} isMobile={isMobile} />
      <SecondaryHeader location={location} isMobile={isMobile} />
      <Content
        className={cx(styles.siteLayout, {
          [styles.isContentFullWidth]: isContentFullWidth,
        })}
      >
        {children}
      </Content>
      {!isMobile && <SiteFooter />}
    </Layout>
  );
};

NavigationLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
  isMobile: PropTypes.bool,
  isContentFullWidth: PropTypes.bool,
};

export default NavigationLayout;
